/**
 * DeeDee AI Wig Try-On Widget - IMPROVED VERSION
 * Features: Download button, fixed previews, better mobile support
 */

(function() {
    'use strict';

    // Configuration
    const CONFIG = {
        n8nWebhookUrl: 'https://n8n.srv1130341.hstgr.cloud/webhook/deedee-wig-tryon',
        maxDailyTries: 3,
        maxFileSize: 10 * 1024 * 1024, // 10MB
        allowedFileTypes: ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'],
        pollInterval: 2000,
        maxPollAttempts: 60,
        requestTimeout: 180000 // 3 minutes (180 seconds) for AI generation
    };

    // DOM Elements
    const elements = {
        widget: document.getElementById('deedee-wig-tryon-widget'),
        form: document.getElementById('deedee-wig-form'),
        usageCount: document.getElementById('deedee-usage-count'),
        status: document.getElementById('deedee-status'),
        result: document.getElementById('deedee-result'),
        resultImage: document.getElementById('deedee-result-image'),
        generateBtn: document.getElementById('deedee-generate-btn'),
        tryAgainBtn: document.getElementById('deedee-try-again-btn'),
        photo1: document.getElementById('deedee-photo-1'),
        photo2: document.getElementById('deedee-photo-2'),
        photo3: document.getElementById('deedee-photo-3'),
        colorSelect: document.getElementById('deedee-wig-color'),
        preview1: document.getElementById('deedee-preview-1'),
        preview2: document.getElementById('deedee-preview-2'),
        preview3: document.getElementById('deedee-preview-3')
    };

    // Global variable to store generated image URL
    let generatedImageUrl = null;

    console.log('🎯 DeeDee Widget: Starting...');

    // Check if widget exists and user is logged in
    if (!elements.widget) {
        console.log('❌ Widget element not found');
        return;
    }

    const isLoggedIn = elements.widget.dataset.customerLoggedIn === 'true';
    const customerId = elements.widget.dataset.customerId;

    console.log('👤 Logged in:', isLoggedIn, '| Customer ID:', customerId);

    if (!isLoggedIn || !customerId) {
        console.log('⚠️ User not logged in');
        return;
    }

    // Initialize the widget
    init();

    /**
     * Initialize widget functionality
     */
    function init() {
        console.log('✅ Initializing widget for customer', customerId);
        
        checkUsageLimit();
        setupImagePreviews();

        if (elements.form) {
            elements.form.addEventListener('submit', handleFormSubmit);
            console.log('✅ Form handler attached');
        }

        if (elements.tryAgainBtn) {
            elements.tryAgainBtn.addEventListener('click', resetWidget);
        }

        console.log('✅ DeeDee Widget fully initialized!');
    }

    /**
     * Check user's remaining daily tries
     */
    async function checkUsageLimit() {
        try {
            console.log('📊 Checking usage limit...');

            const response = await fetch(CONFIG.n8nWebhookUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    action: 'check_usage',
                    customer_id: customerId
                })
            });

            const data = await response.json();
            console.log('📊 Usage data:', data);

            if (data.tries_remaining !== undefined) {
                updateUsageDisplay(data.tries_remaining);
            }

        } catch (error) {
            console.error('❌ Error checking usage:', error);
            showStatus('Could not check usage limit. Please try again.', 'error');
        }
    }

    /**
     * Update usage counter display
     */
    function updateUsageDisplay(triesRemaining) {
        if (elements.usageCount) {
            elements.usageCount.innerHTML = `<strong>${triesRemaining}/${CONFIG.maxDailyTries}</strong>`;
            
            if (triesRemaining === 0) {
                elements.usageCount.style.color = '#f5576c';
                if (elements.generateBtn) {
                    elements.generateBtn.disabled = true;
                    elements.generateBtn.textContent = 'Daily Limit Reached';
                }
            } else if (triesRemaining === 1) {
                elements.usageCount.style.color = '#ff9800';
            } else {
                elements.usageCount.style.color = '#4caf50';
            }
        }
    }

    /**
     * Setup image preview functionality - FIXED
     */
    function setupImagePreviews() {
        setupPreview(elements.photo1, elements.preview1, '1');
        setupPreview(elements.photo2, elements.preview2, '2');
        setupPreview(elements.photo3, elements.preview3, '3');
    }

    /**
     * Setup preview for a single file input - IMPROVED
     */
    function setupPreview(input, preview, number) {
        if (!input || !preview) {
            console.warn(`⚠️ Photo ${number} elements not found`);
            return;
        }

        input.addEventListener('change', function(e) {
            const file = e.target.files[0];
            
            if (!file) {
                preview.innerHTML = '';
                preview.style.display = 'none';
                return;
            }

            console.log(`📸 Photo ${number} selected:`, file.name, `(${(file.size / 1024 / 1024).toFixed(2)}MB)`);

            // Validate file
            const validation = validateFile(file);
            if (!validation.valid) {
                showStatus(validation.error, 'error');
                input.value = '';
                preview.innerHTML = '';
                preview.style.display = 'none';
                return;
            }

            // Create preview - FIXED VERSION
            const reader = new FileReader();
            reader.onload = function(e) {
                const img = document.createElement('img');
                img.src = e.target.result;
                img.alt = `Photo ${number} preview`;
                img.style.width = '100%';
                img.style.height = '100%';
                img.style.objectFit = 'cover';
                img.style.borderRadius = '8px';
                
                preview.innerHTML = '';
                preview.appendChild(img);
                preview.style.display = 'block';
                
                console.log(`✅ Photo ${number} preview created successfully`);
            };
            
            reader.onerror = function() {
                console.error(`❌ Error reading photo ${number}`);
                showStatus(`Could not read photo ${number}. Please try again.`, 'error');
                preview.innerHTML = '';
                preview.style.display = 'none';
            };
            
            reader.readAsDataURL(file);
        });
    }

    /**
     * Validate uploaded file
     */
    function validateFile(file) {
        if (!CONFIG.allowedFileTypes.includes(file.type)) {
            return {
                valid: false,
                error: 'Please upload a valid image file (JPG, PNG, or WebP)'
            };
        }

        if (file.size > CONFIG.maxFileSize) {
            return {
                valid: false,
                error: `File size must be less than ${CONFIG.maxFileSize / 1024 / 1024}MB`
            };
        }

        return { valid: true };
    }

    /**
     * Handle form submission - WITH DOUBLE-SUBMIT PREVENTION
     */
    let isSubmitting = false; // Prevent double submission
    
    async function handleFormSubmit(e) {
        e.preventDefault();
        
        // Prevent double submission
        if (isSubmitting) {
            console.log('⚠️ Already submitting, ignoring duplicate request');
            return;
        }
        
        console.log('🚀 Form submitted!');

        if (!validateForm()) {
            return;
        }

        isSubmitting = true; // Lock submission
        setLoadingState(true);
        showStatus('Preparing your photos...', 'info');

        try {
            // Convert photos to base64
            const photos = await Promise.all([
                fileToBase64(elements.photo1.files[0]),
                fileToBase64(elements.photo2.files[0]),
                fileToBase64(elements.photo3.files[0])
            ]);

            console.log('✅ Photos converted:', {
                photo1Length: photos[0].length,
                photo2Length: photos[1].length,
                photo3Length: photos[2].length
            });

            // Get additional data
            const wigColor = elements.colorSelect.value;
            const productTitle = document.getElementById('deedee-product-title')?.value || 'Wig';
            const customerEmail = document.getElementById('deedee-customer-email')?.value || '';

            const requestData = {
                action: 'generate_tryon',
                customer_id: customerId,
                customer_email: customerEmail,
                photo_1: photos[0],
                photo_2: photos[1],
                photo_3: photos[2],
                wig_color: wigColor,
                wig_model: productTitle
            };

            const requestSize = (JSON.stringify(requestData).length / 1024).toFixed(2);
            console.log('📤 Sending try-on request... Request size:', requestSize, 'KB');

            // Show initial loading message
            showStatus('🎨 AI is generating your try-on...', 'info');
            
            // Start countdown timer (2 minutes estimate)
            let countdown = 120; // Estimated time for InstantID
            const countdownInterval = setInterval(() => {
                if (countdown > 0) {
                    countdown--;
                    if (countdown > 90) {
                        showStatus(`🎨 Generating your try-on... ${countdown}s remaining`, 'info');
                    } else if (countdown > 60) {
                        showStatus(`🎨 Still generating... ${countdown}s remaining`, 'info');
                    } else if (countdown > 30) {
                        showStatus(`⏱️ Almost done... ${countdown}s remaining`, 'info');
                    } else if (countdown > 0) {
                        showStatus(`✨ Finalizing... ${countdown}s remaining`, 'info');
                    }
                }
            }, 1000);

            try {
                // Create abort controller for timeout
                const controller = new AbortController();
                const timeoutId = setTimeout(() => {
                    controller.abort();
                    console.log('⏱️ Request timeout after 90 seconds');
                }, CONFIG.requestTimeout);

                // Send to n8n with timeout
                const response = await fetch(CONFIG.n8nWebhookUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(requestData),
                    signal: controller.signal
                });

                // Clear timeout and countdown if successful
                clearTimeout(timeoutId);
                clearInterval(countdownInterval);

                console.log('📥 Response status:', response.status);

                if (!response.ok) {
                    throw new Error(`Server responded with ${response.status}`);
                }

                const result = await response.json();
                console.log('✅ Try-on result:', result);

                if (result.success) {
                    handleSuccess(result);
                } else {
                    throw new Error(result.error || 'AI generation failed');
                }

            } catch (fetchError) {
                // Clean up countdown on error
                clearInterval(countdownInterval);
                
                // Handle abort/timeout specifically
                if (fetchError.name === 'AbortError') {
                    throw new Error('Request timeout. AI generation is taking longer than expected. Please try again.');
                }
                throw fetchError;
            }

        } catch (error) {
            console.error('❌ Error:', error);
            handleError(error);
        } finally {
            setLoadingState(false);
            isSubmitting = false; // Reset submission lock
        }
    }

    /**
     * Validate form fields
     */
    function validateForm() {
        if (!elements.photo1.files[0] || !elements.photo2.files[0] || !elements.photo3.files[0]) {
            showStatus('Please upload all 3 photos', 'error');
            return false;
        }

        if (!elements.colorSelect.value) {
            showStatus('Please select a wig color', 'error');
            return false;
        }

        return true;
    }

    /**
     * Compress image for mobile devices
     * Reduces file size while maintaining quality
     */
    async function compressImage(file, maxWidth = 1024, quality = 0.85) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            
            reader.onload = (e) => {
                const img = new Image();
                
                img.onload = () => {
                    // Create canvas
                    const canvas = document.createElement('canvas');
                    let width = img.width;
                    let height = img.height;
                    
                    // Calculate new dimensions (maintain aspect ratio)
                    if (width > maxWidth) {
                        height = (height * maxWidth) / width;
                        width = maxWidth;
                    }
                    
                    canvas.width = width;
                    canvas.height = height;
                    
                    // Draw and compress
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0, width, height);
                    
                    // Convert to blob with compression
                    canvas.toBlob(
                        (blob) => {
                            if (blob) {
                                console.log(`📉 Compressed: ${(file.size / 1024 / 1024).toFixed(2)}MB → ${(blob.size / 1024 / 1024).toFixed(2)}MB`);
                                resolve(blob);
                            } else {
                                reject(new Error('Compression failed'));
                            }
                        },
                        'image/jpeg',
                        quality
                    );
                };
                
                img.onerror = reject;
                img.src = e.target.result;
            };
            
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    }

    /**
     * Convert file to base64 WITH MOBILE COMPRESSION
     */
    async function fileToBase64(file) {
        try {
            // Check if file is large (> 2MB)
            const isLarge = file.size > 2 * 1024 * 1024;
            
            if (isLarge) {
                console.log(`🔧 Large file detected (${(file.size / 1024 / 1024).toFixed(2)}MB), compressing...`);
                
                // Compress the image
                const compressedBlob = await compressImage(file, 1024, 0.85);
                
                // Convert compressed blob to base64
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = reject;
                    reader.readAsDataURL(compressedBlob);
                });
            } else {
                // Small file, use as-is
                console.log(`✅ File size OK (${(file.size / 1024 / 1024).toFixed(2)}MB), no compression needed`);
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = reject;
                    reader.readAsDataURL(file);
                });
            }
        } catch (error) {
            console.error('❌ Compression error:', error);
            // Fallback: try without compression
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
        }
    }

    /**
     * Handle successful generation - WITH DOWNLOAD BUTTON
     */
    function handleSuccess(result) {
        console.log('🎉 SUCCESS! Image generated');

        // Try multiple possible field names for the image URL
        const imageUrl = result.generated_image_url || 
                        result.generated_image || 
                        result.image_url ||
                        result.output_url;

        if (!imageUrl) {
            console.error('❌ No image URL in response:', result);
            showStatus('Image generated but URL not found. Please try again.', 'error');
            return;
        }

        generatedImageUrl = imageUrl;
        console.log('🖼️ Image URL:', imageUrl);

        // Update usage count
        if (result.tries_remaining !== undefined) {
            updateUsageDisplay(result.tries_remaining);
        }

        // Show result section with DOWNLOAD button
        showStatus('✨ Your AI try-on is ready!', 'success');
        
        if (elements.result) {
            // Create download button and preview
            elements.result.innerHTML = `
                <h4 class="deedee-result-title">✨ Your AI Try-On Result:</h4>
                <div class="deedee-result-preview">
                    <img src="${imageUrl}" 
                         alt="AI Wig Try-On Result" 
                         style="max-width: 100%; height: auto; border-radius: 12px; margin: 15px 0;">
                </div>
                <div class="deedee-result-actions" style="display: flex; gap: 10px; flex-wrap: wrap;">
                    <button type="button" 
                            id="deedee-download-btn" 
                            class="deedee-wig-download t4s-btn t4s-btn-base t4s-btn-style-default t4s-btn-color-main"
                            style="flex: 1; min-width: 200px;">
                        ⬇️ Download Your Try-On
                    </button>
                    <button type="button" 
                            id="deedee-try-again-btn-new" 
                            class="deedee-wig-try-again t4s-btn t4s-btn-base t4s-btn-style-outline t4s-btn-color-main"
                            style="flex: 1; min-width: 200px;">
                        🔄 Try Another Color
                    </button>
                </div>
            `;
            
            elements.result.style.display = 'block';

            // Attach download handler
            const downloadBtn = document.getElementById('deedee-download-btn');
            if (downloadBtn) {
                downloadBtn.addEventListener('click', downloadImage);
            }

            // Attach try again handler
            const tryAgainBtnNew = document.getElementById('deedee-try-again-btn-new');
            if (tryAgainBtnNew) {
                tryAgainBtnNew.addEventListener('click', resetWidget);
            }

            // Scroll to result
            elements.result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }

        console.log('✅ Result displayed with download button');
    }

    /**
     * Download generated image
     */
    async function downloadImage() {
        if (!generatedImageUrl) {
            showStatus('No image to download', 'error');
            return;
        }

        try {
            showStatus('Preparing download...', 'info');
            
            // Fetch the image
            const response = await fetch(generatedImageUrl);
            const blob = await response.blob();
            
            // Create download link
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `deedee-wig-tryon-${Date.now()}.png`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            
            showStatus('✅ Download started!', 'success');
            console.log('✅ Download initiated');
            
        } catch (error) {
            console.error('❌ Download error:', error);
            // Fallback: open in new tab
            window.open(generatedImageUrl, '_blank');
            showStatus('Opening image in new tab...', 'info');
        }
    }

    /**
     * Handle error
     */
    function handleError(error) {
        let errorMessage = 'Something went wrong. Please try again.';
        
        if (error.message) {
            errorMessage = error.message;
        }
        
        showStatus(`❌ ${errorMessage}`, 'error');
        console.error('Error details:', error);
    }

    /**
     * Reset widget to try again
     */
    function resetWidget() {
        console.log('🔄 Resetting widget');
        
        // Clear form
        if (elements.form) {
            elements.form.reset();
        }
        
        // Clear previews
        [elements.preview1, elements.preview2, elements.preview3].forEach(preview => {
            if (preview) {
                preview.innerHTML = '';
                preview.style.display = 'none';
            }
        });
        
        // Hide result
        if (elements.result) {
            elements.result.style.display = 'none';
        }
        
        // Clear status
        if (elements.status) {
            elements.status.innerHTML = '';
            elements.status.className = 'deedee-wig-status';
        }
        
        // Reset generated image URL
        generatedImageUrl = null;
        
        // Re-enable button
        setLoadingState(false);
        
        // Scroll to form
        if (elements.form) {
            elements.form.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        
        console.log('✅ Widget reset');
    }

    /**
     * Set loading state
     */
    function setLoadingState(loading) {
        if (elements.generateBtn) {
            const btnText = elements.generateBtn.querySelector('.deedee-btn-text');
            const btnLoading = elements.generateBtn.querySelector('.deedee-btn-loading');
            
            if (loading) {
                elements.generateBtn.disabled = true;
                if (btnText) btnText.style.display = 'none';
                if (btnLoading) btnLoading.style.display = 'inline-flex';
            } else {
                elements.generateBtn.disabled = false;
                if (btnText) btnText.style.display = 'inline';
                if (btnLoading) btnLoading.style.display = 'none';
            }
        }
    }

    /**
     * Show status message
     */
    function showStatus(message, type = 'info') {
        if (!elements.status) return;
        
        const icons = {
            info: 'ℹ️',
            success: '✅',
            error: '❌',
            warning: '⚠️'
        };
        
        elements.status.innerHTML = `${icons[type] || ''} ${message}`;
        elements.status.className = `deedee-wig-status deedee-status-${type}`;
        
        // Auto-hide success messages after 5 seconds
        if (type === 'success') {
            setTimeout(() => {
                if (elements.status.classList.contains('deedee-status-success')) {
                    elements.status.innerHTML = '';
                    elements.status.className = 'deedee-wig-status';
                }
            }, 5000);
        }
    }

    // Expose debug methods
    window.DeeDeeWidget = {
        checkUsage: checkUsageLimit,
        reset: resetWidget,
        download: downloadImage,
        customerId: customerId,
        generatedUrl: () => generatedImageUrl
    };

    console.log('✅ DeeDee Widget initialized!');
    console.log('💡 Debug: window.DeeDeeWidget available for testing');

})();